import React from 'react';

// URL resolver helper to handle image paths correctly
const resolveUrl = (url, folderName = '') => {
  if (!url) return '';
  let cleanUrl = url.replace(/(process\.env\.REACT_APP_API_BASE \|\| '')\+?/g, "");
  cleanUrl = cleanUrl.replace(/['"]/g, ''); 
  if (cleanUrl.startsWith('http') || cleanUrl.startsWith('data:') || cleanUrl.startsWith('blob:')) {
    return cleanUrl;
  }
  if (!cleanUrl.includes('uploads/') && folderName) {
    cleanUrl = `uploads/${folderName}/${cleanUrl.replace(/^\/+/, '')}`;
  }
  const baseUrl = process.env.REACT_APP_API_BASE || 'http://localhost:3001';
  return `${baseUrl.replace(/\/$/, '')}/${cleanUrl.replace(/^\//, '')}`;
};

export default function TerritoryCard({ t, index }) {
  // If no territory data is passed, don't render anything
  if (!t) return null;

  return (
    <div 
      style={{ 
        background: '#fff', 
        border: '1px solid rgba(122,140,136,.18)', 
        borderRadius: 8, 
        overflow: 'hidden', 
        transition: 'all .2s ease',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
      onMouseEnter={e => { 
        e.currentTarget.style.transform = 'translateY(-4px)'; 
        e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,.08)'; 
      }}
      onMouseLeave={e => { 
        e.currentTarget.style.transform = 'none'; 
        e.currentTarget.style.boxShadow = 'none'; 
      }}
    >
      {/* Top Banner / Image Area */}
      <div style={{ height: 120, position: 'relative', background: t.color || 'var(--radar-deep)', overflow: 'hidden' }}>
        {t.heroImageUrl && (
          <img 
            src={resolveUrl(t.heroImageUrl, 'territories')} 
            alt={t.name} 
            style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.8 }} 
          />
        )}
        
        {/* Avatar positioned over the banner border */}
        {t.avatarUrl && (
          <div style={{ 
            position: 'absolute', 
            bottom: -20, 
            left: 20, 
            width: 56, 
            height: 56, 
            borderRadius: '50%', 
            border: '3px solid #fff',
            background: '#fff',
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0,0,0,.15)'
          }}>
            <img 
              src={resolveUrl(t.avatarUrl, 'avatars')} 
              alt={`${t.name} logo`} 
              style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
            />
          </div>
        )}
      </div>

      {/* Text Content Area */}
      <div style={{ padding: '32px 20px 20px', display: 'flex', flexDirection: 'column', flex: 1 }}>
        <h3 style={{ fontSize: 20, fontWeight: 700, color: 'var(--radar-dark)', marginBottom: 6 }}>
          {t.name}
        </h3>
        
        <div style={{ fontFamily: 'Space Mono,monospace', fontSize: 10, color: 'var(--radar-mid)', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 14 }}>
          {t.region} {t.department ? `· ${t.department}` : ''}
        </div>
        
        <p style={{ fontSize: 13, color: '#5A6B68', lineHeight: 1.5, marginBottom: 20, flex: 1 }}>
          {t.description ? (
            t.description.length > 90 ? `${t.description.substring(0, 90)}...` : t.description
          ) : (
            'Découvrez ce territoire et participez au jeu de piste.'
          )}
        </p>
        
        {/* Stats Row */}
        <div style={{ display: 'flex', gap: 16, paddingTop: 16, borderTop: '1px solid rgba(122,140,136,.15)' }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: t.color || 'var(--radar-deep)' }}>
              {t.players || 0}
            </div>
            <div style={{ fontSize: 9, fontFamily: 'Space Mono,monospace', color: 'var(--radar-mid)', textTransform: 'uppercase' }}>
              Joueurs
            </div>
          </div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: t.color || 'var(--radar-deep)' }}>
              {t.teams || 0}
            </div>
            <div style={{ fontSize: 9, fontFamily: 'Space Mono,monospace', color: 'var(--radar-mid)', textTransform: 'uppercase' }}>
              Équipes
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}